import { useMemo, useState } from 'react'
import GuideCard from './GuideCard'
import { GuideSummary } from '../types/guides'

interface GuideListProps {
  guides: GuideSummary[]
  limit?: number
  showFilters?: boolean
  emptyText?: string
}

const sortGuides = (guides: GuideSummary[]) => [...guides].sort(
  (left, right) => right.date.localeCompare(left.date) || left.slug.localeCompare(right.slug)
)

const GuideList = ({ guides, limit, showFilters = true, emptyText = '暂无资料' }: GuideListProps) => {
  const [activeCategory, setActiveCategory] = useState('全部')
  const categories = useMemo(() => ['全部', ...Array.from(new Set(guides.map(guide => guide.category)))], [guides])
  const visibleGuides = useMemo(() => {
    const filtered = activeCategory === '全部'
      ? guides
      : guides.filter(guide => guide.category === activeCategory)
    const sorted = sortGuides(filtered)
    return limit === undefined ? sorted : sorted.slice(0, limit)
  }, [activeCategory, guides, limit])

  return (
    <div>
      {showFilters && guides.length > 0 && (
        <div className="mb-6 flex gap-2 overflow-x-auto pb-1" aria-label="资料分类">
          {categories.map(category => (
            <button
              key={category}
              type="button"
              className={`shrink-0 rounded-md border px-3 py-1.5 text-sm transition ${
                activeCategory === category
                  ? 'border-slate-950 bg-slate-950 text-white'
                  : 'border-slate-200 bg-white text-slate-700 hover:border-slate-400'
              }`}
              onClick={() => setActiveCategory(category)}
            >
              {category}
            </button>
          ))}
        </div>
      )}

      {visibleGuides.length > 0 ? (
        <div>
          {visibleGuides.map(guide => <GuideCard key={guide.slug} guide={guide} />)}
        </div>
      ) : (
        <p className="border-y border-slate-200 py-10 text-center text-sm text-slate-500">{emptyText}</p>
      )}
    </div>
  )
}

export default GuideList
